module.exports = __webpack_public_path__ + "static/media/autochilango-thumbs.91107e98.svg";